import { useEffect } from "react";
import { Box, HStack, VStack } from "../../components/utils";
import BCHeader from "../../shared/BCHeader";
import AddTemplateSplit from "./AddTemplateSplit";
import { useQuickSplitTransactionStore } from "../../store/useQuickTransactionStore";
import { useAuthStore } from "../../store";
import { useGetOnGoingTransaction } from "../../queries/transactionRound";
import TransactionPreviewPage from "./TransactionPreviewPage";
import StepperQuickSplitTransaction from "./StepperSplitTransaction";
import QuickAddSplit from "./QuickAddSplit";

function TransactionSplitTemplate() {
  const { state: template, setState: setTemplate } =
    useQuickSplitTransactionStore();
  const stepNo = template.stepNo;
  const companyId = useAuthStore.getState().companyId || "";
  const { refetch, data: onGoingTransaction } =
    useGetOnGoingTransaction(companyId);
  useEffect(() => {
    refetch();
  }, []);
  useEffect(() => {
    if (onGoingTransaction) setTemplate(onGoingTransaction);
    else {
      setTemplate({ stepNo: 1, transactionType: "split", companyId });
    }
  }, [onGoingTransaction]);

  return (
    <div className="min-h-full">
      <BCHeader
        className="items-baseline mb-2"
        bcTitle="Transaction Dashboard"
        bcSubTitle="Add split"
      />
      {template.stepNo !== 2 ? <QuickAddSplit /> : null}
      {template.stepNo === 2 ? <TransactionPreviewPage /> : null}
    </div>
  );
}

export default TransactionSplitTemplate;
